import { render, staticRenderFns } from "./PricingChange.vue?vue&type=template&id=c892089a"
import script from "./PricingChange.vue?vue&type=script&lang=js"
export * from "./PricingChange.vue?vue&type=script&lang=js"
import style0 from "./PricingChange.vue?vue&type=style&index=0&id=c892089a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c892089a')) {
      api.createRecord('c892089a', component.options)
    } else {
      api.reload('c892089a', component.options)
    }
    module.hot.accept("./PricingChange.vue?vue&type=template&id=c892089a", function () {
      api.rerender('c892089a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/PricingChange.vue"
export default component.exports